import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {BrowserRouter} from "react-router-dom";

// Don't auto-open the login modal just because the user landed on / refreshed
// the app URL. The "ShowLoginDialog" flag persists in sessionStorage (e.g. it's
// set on logout), so without this a fresh landing re-pops the login screen.
// Clearing it on page load means login only opens via an explicit action
// (account icon / Home's Login button). In-session logout uses SPA navigation
// (no page reload), so this does not run then and logout still shows login.
if (sessionStorage.getItem("ShowLoginDialog") === "true") {
    sessionStorage.setItem("ShowLoginDialog", "false");
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <BrowserRouter>
       <App />
    </BrowserRouter>
);
